<template>
    <div class="landingPage" :class="isMobile ? 'h5' : 'pc'">
        <template v-if="!isMobile">
            <div class="countdown" style="z-index:5;">
                <div class="text1 ret">
                    {{ countdownIndependent(deadline, 'dd') }}
                    <span class="abs">days left</span>
                </div>
                <p class="text2">
                    {{ countdownIndependent(deadline, 'hh') }} <span class="text3">H &nbsp;</span>
                    {{ countdownIndependent(deadline, 'mm') }} <span class="text3">MIN &nbsp;</span>
                    {{ countdownIndependent(deadline, 'ss') }} <span class="text3">S</span>
                </p>
                <p class="text4">
                    <!-- Before we launch our new website -->
                </p>
                <div @click="contactUs(0)" class="fake-btn">Notify Me</div>
            </div>
            <div class="swiper" style="z-index:5;">
                <div class="swiper-banner">
                    <div class="swiper-wrapper">
                        <section class="swiper-slide">
                            <div class="line"><span class="text1 underline">Let's meet</span></div>
                            <p class="text2">Stay tuned for something awesome.</p>
                        </section>
                        <section class="swiper-slide">
                            <div class="line"><span class="text1 underline">CONTACT</span></div>
                            <p class="text1">EMAIL</p>
                            <p class="text3">
                                <a style="color:#fff" href="mailto:info@playestates.com">info@playestates.com</a>
                            </p>
                            <p class="text1">FIND US ON</p>
                            <p class="logo">
                                <img @click="contactUs(1)" src="@/assets/social_media/twitter.svg">
                                <img @click="contactUs(2)" src="@/assets/social_media/discord.svg">
                            </p>
                        </section>
                    </div>
                    <div class="swiper-pagination"></div>
                </div>
            </div>
        </template>
        <div class="h5-inner" style="z-index:5;" v-else-if="isMobile">
            <div class="countdown desc" style="z-index:5;">
                <div class="text1 ret">
                    {{ countdownIndependent(deadline, 'dd') }}
                    <span class="abs">days left</span>
                </div>
                <p class="text2">
                    {{ countdownIndependent(deadline, 'hh') }} <span class="text3">H &nbsp;</span>
                    {{ countdownIndependent(deadline, 'mm') }} <span class="text3">MIN &nbsp;</span>
                    {{ countdownIndependent(deadline, 'ss') }} <span class="text3">S</span>
                </p>
                <p class="text4">
                    <!-- Before we launch our new website -->
                </p>
                <div @click="contactUs(0)" class="fake-btn">Notify Me</div>
            </div>
            <section class="desc">
                <div class="line"><span class="text1 underline">Let's meet</span></div>
                <p class="text2">Stay tuned for something awesome.</p>
            </section>
            <section class="desc">
                <div class="line"><span class="text1 underline">CONTACT</span></div>
                <p class="text1">EMAIL</p>
                <p class="text3">
                    <a style="color:#fff" href="mailto:info@playestates.com">info@playestates.com</a>
                </p>
                <p class="text1">FIND US ON</p>
                <p class="logo" style="margin-top: 30rem;">
                    <img style="width:50rem;height:50rem;margin-right:50rem;" @click="contactUs(1)" src="@/assets/social_media/twitter.svg">
                    <img style="width:50rem;height:50rem;" @click="contactUs(2)" src="@/assets/social_media/discord.svg">
                </p>
            </section>
        </div>
        <a-modal v-model="showMD" width="455rem" :footer="null" :destroyOnClose="true" :bodyStyle="bodyStyle" centered
            @cancel="showMD = false">
            <h3 class="title">Get to know about our launch</h3>
            <p class="tip">Subscribe to our newsletter and we will send you a notification about the launch of our brand new
                site.</p>
            <a-input placeholder="Your Email" v-model="email" />
            <div class="fake-btn cursor" @click="contactUs(3)">Submit</div>
        </a-modal>
        <div class="earthCss" ref="earthRef"></div>
    </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import Earth from "@/utils/earth.js";
import { countdownIndependent } from "@/utils/tools.js";
import { notify_email } from "@/utils/api.js";
import { isMobileDevice } from "../config/device";
var threeEarth;
var Timer0601;
export default {
    data() {
        return {
            mSwiper: null,
            showMD: false,
            isMobile: false,
            bodyStyle: {
                background: "#212126",
                borderRadius: "20rem",
                border: "2rem solid #666666",
                padding: "50rem",
                boxShadow: "none",
                minHeight: "360rem",
            },
            cityList: [
                "hilippines",
                "Nigeria",
                "France",
                "Ukraine",
                "Russia",
                "Germany",
                "Singapore",
                "Malaysia",
                "Indonesia",
                "Turkey",
                "Germany",
                "India",
                "P", //首位会相连，所以出此下策
            ],
            countdown: {
                Day: 0,
                hour: 0,
                minute: 0,
                second: 0,
            },
            deadline: process.env.VUE_APP_COUNTDOWN,
            email: "",
        };
    },
    methods: {
        countdownIndependent,
        async contactUs(t) {
            switch (t) {
                case 0:
                    this.showMD = true;
                    break;
                case 1:
                    window.open("https://twitter.com/PlayEstates", "_blank");
                    break;
                case 2:
                    window.open("https://discord.gg/playestates", "_blank");
                    break;
                case 3:
                    let test = new RegExp(/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/);
                    if (!test.test(this.email))
                        return this.$message.error("Please enter a valid email address");
                    const { success } = await notify_email(this.email);
                    if (!success) return this.$message.error("error!");
                    this.showMD = false;
                    setTimeout(() => {
                        this.email = "";
                    }, 500);
                    this.$message.success("Submit success!");
                    break;
            }
        },
    },
    mounted() {
        Timer0601 = setInterval(() => {
            this.deadline = +this.deadline - 1;
            this.deadline = +this.deadline + 1;
        }, 1000);
        this.isMobile = isMobileDevice()
        !this.isMobile && (this.mSwiper = new Swiper(".swiper-banner", {
            loop: true,
            effect: "fade",
            direction: "vertical",
            pagination: {
                el: ".swiper-pagination",
                type: "bullets",
                clickable: true,
            },
            autoplay: {
                delay: 5000,
                stopOnLastSlide: false,
                disableOnInteraction: false,
            },
        }))
        threeEarth = new Earth(this.$refs.earthRef, this.cityList);
    },
    beforeDestroy() {
        clearInterval(Timer0601);
        threeEarth.remove();
    },
};
</script>

<style lang='less' scoped>
::v-deep {
    .ant-modal-content {
        border-radius: 100rem;

        .ant-modal-close-icon {
            color: #eee;
        }

        .title {
            font-size: 18rem;
            font-family: Michroma;
            color: #fff;
            white-space: nowrap;
        }

        .tip {
            margin: 30rem 0 !important;
            font-size: 14rem;
            font-family: Inter-Regular, Inter;
            color: #cccccc;
        }

        .ant-input {
            width: 355rem;
            height: 54rem;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 8rem;
            color: #fff;
            border: none;
            padding-left: 20rem;

            &:focus {
                box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.2);
            }
        }

        .fake-btn {
            margin: 30rem auto 0;
            height: 54rem;
        }
    }
}

.landingPage {
    user-select: none;
    height: calc(100vh - 100rem);
    background-color: #000;

    .earthCss {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0.5;
        width: 100%;
        height: 100%;
        font-size: 40rem;
        color: #fff;
        // z-index: -1;
    }

    .countdown,
    .swiper {
        flex: 1;
        margin-top: -100rem;
    }

    .countdown {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #fff;
        font-family: Inter-Regular_Bold, Inter;
        padding-left: 200rem;

        .ret {
            position: relative;

            .abs {
                position: absolute;
                right: -80%;
                bottom: 35rem;
                font-size: 20rem;
            }
        }

        .text1 {
            font-size: 100rem;
        }

        .text2 {
            font-size: 36rem;
        }

        .text3 {
            font-family: Inter-Regular, Inter;
            color: #dddddd;
        }

        .text4 {
            margin-top: 30rem;
            font-size: 18rem;
            font-family: Inter-Regular, Inter;
        }

        .fake-btn {
            margin-top: 60rem;
            width: 180rem;
            height: 54rem;
            font-size: 16rem;
            font-family: Michroma;
            line-height: 23rem;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
        }
    }

    .swiper {
        z-index: 5;
        height: 400rem;
        overflow: hidden;
        position: relative;
        width: 80%;

        ::v-deep {
            .swiper-banner {
                overflow: hidden;
                position: relative;

                .swiper-pagination {
                    height: 120rem;
                    padding-right: 50rem;
                    right: 0;
                    top: 200rem;
                    transform: translateY(-60rem);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    .swiper-pagination-bullet {
                        width: 12rem;
                        height: 12rem;
                        margin: 12rem 0rem !important;
                        opacity: 0.5;
                        background: #999;
                    }

                    .swiper-pagination-bullet-active {
                        opacity: 1;
                        width: 16rem;
                        height: 16rem;
                        background: #fff;
                    }
                }

                .swiper-wrapper {
                    .swiper-slide {
                        opacity: 0 !important;

                        &.swiper-slide-active {
                            opacity: 1 !important;
                        }

                        width: 100% !important;
                        height: 400rem !important;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        color: #fff;

                        .line {
                            margin-bottom: 50rem !important;
                        }

                        .text1 {
                            font-size: 34rem;
                            font-family: Michroma;
                            position: relative;

                            &.underline {
                                &::after {
                                    position: absolute;
                                    bottom: -5rem;
                                    left: 0;
                                    display: inline-block;
                                    content: "";
                                    width: 100%;
                                    height: 4rem;
                                    border-radius: 10rem;
                                    background: linear-gradient(90deg, #435cc8 0%, #58f9c3 100%);
                                }
                            }
                        }

                        .text2 {
                            font-size: 32rem;
                            font-family: Inter-Regular_Bold, Inter;
                            color: #ffffff;
                            line-height: 39rem;
                            margin-bottom: 30rem !important;
                        }

                        .text3 {
                            font-size: 21rem;
                            font-family: Inter-Regular, Inter;
                            line-height: 25rem;
                            margin: 10rem 0 50rem !important;
                        }

                        .logo {
                            img {
                                cursor: pointer;
                                width: 40rem;
                                height: 40rem;
                                margin: 10rem 40rem 0 0;
                            }
                        }
                    }
                }
            }
        }
    }

}

.pc {
    display: flex;
    align-items: center;
    position: relative;
}

.h5 {
    display: flex;
    align-items: center;
    position: relative;
    flex-direction: column;
    justify-content: center;

    .h5-inner {
        height: 60%;
        width: 100%;
        overflow-y: auto;
        overflow-x: hidden;

        .countdown {
            display: flex;
            flex-direction: column;
            align-items: center;
            color: #fff;
            font-family: Inter-Regular_Bold, Inter;
            padding-left: 0;

            .ret {
                position: relative;

                .abs {
                    position: absolute;
                    right: -200%;
                    bottom: 5rem;
                    font-size: 20rem;
                }
            }
        }

        .desc {
            margin-top: -50rem;
            color: #FFF;
            height: 100%;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;



            .line {
                margin-bottom: 50rem !important;
            }

            .text1 {
                font-size: 34rem;
                font-family: Michroma;
                position: relative;

                &.underline {
                    &::after {
                        position: absolute;
                        bottom: -5rem;
                        left: 0;
                        display: inline-block;
                        content: "";
                        width: 100%;
                        height: 4rem;
                        border-radius: 10rem;
                        background: linear-gradient(90deg, #435cc8 0%, #58f9c3 100%);
                    }
                }
            }
        }
    }
}
</style>